import { useEffect, useState } from 'react'
import { get, isEmpty, isNil } from 'lodash'
import find from 'lodash/fp/find'
import useStoreSelector from 'utils/hooks/useStoreSelector'
import { defaultPermission } from 'pages/Scenario/state'

const getFirstMainInstance = find(({ config }) => isNil(config))

const modelPermissionsSelector = ({ scenarioModelConfig }) => {
  return get(scenarioModelConfig, 'scenario.permissions', defaultPermission)
}

const useRedirect = ({ fallbackPath = '/home', forceRedirectPath = false }) => {
  const [path, setPath] = useState(null)

  const user = useStoreSelector('user')
  const appReady = useStoreSelector('appReady')
  const { permissions } = useStoreSelector('scenario')
  const mainInstance = useStoreSelector('instances', getFirstMainInstance)
  const scenarioModelPermissions = useStoreSelector(
    'appConfig',
    modelPermissionsSelector
  )

  useEffect(() => {
    if (appReady && !isEmpty(user)) {
      // permissions
      const { owner, others } = permissions

      if (forceRedirectPath && fallbackPath) {
        setPath(fallbackPath)
        return
      }

      if (scenarioModelPermissions.read && (owner || others)) {
        setPath('/scenario/management')
        return
      }

      if (mainInstance) {
        setPath(`/instances/${mainInstance.id}/workingTables`)
        return
      }

      setPath(fallbackPath)
    }
  }, [appReady, user, mainInstance, permissions])

  return path
}

export default useRedirect
